import type Owner from '@ember/owner';
import EmberRouter from '@ember/routing/router';
import type Transition from '@ember/routing/transition';
import { type Registry as Services, service } from '@ember/service';
import { tracked } from '@glimmer/tracking';
import config from 'frontend-payments/config/environment';

export default class Router extends EmberRouter {
  @service declare usageAnalytics: Services['usage-analytics'];

  @tracked lastURLUsageAnalytics: string | null = null;

  location = config.locationType;
  rootURL = config.rootURL;

  constructor(owner: Owner) {
    super(owner);

    // Track page views on route changes, similar to Lumen's approach
    this.on('routeDidChange', (transition: Transition) => {
      const willTransitionToDifferentRoute =
        !!transition.from &&
        !!transition.to &&
        transition.from.name !== transition.to.name;

      /*
       * Segment usage tracking
       * We track the page view on every route change
       * Even on query parameter changes, when the route stays the same
       * Note: prevent duplicate events for the same URL
       * Make sure we track transitions between different routes
       */
      if (
        willTransitionToDifferentRoute ||
        this.lastURLUsageAnalytics !== this.url
      ) {
        this.usageAnalytics.page();
        this.lastURLUsageAnalytics = this.url;
      }
    });
  }
}

Router.map(function () {
  this.route('authenticated', { path: '' }, function () {
    this.route('billing-admins');
    this.route('overview', { path: '/' });
    this.route('payment-method');
  });
  this.route('login');
});
